<template>
  <div>
    <side-bar
      :items="filteredItems"
      :width="sideBarWidth"
      class="d-none d-lg-block"
    />
    <bottom-bar
      :items="filteredItems"
      :height="bottomBarHeight"
      class="d-lg-none"
    />
  </div>
</template>

<script>
import { messages } from '@/utils/strings'
import BottomBar from './BottomBar'
import SideBar from './SideBar'
import { stockManagement, userManagement } from '@/constants/permitted-actions'
import { mayAccessPriorityManager } from '@/utils/priority-manager-access'
import { mapGetters } from 'vuex'
import { NOTIFICATION_PAGE, STOCK_COUNT_PAGE } from '@/constants/route-names'
import { NOTIFICATION_SETTINGS } from '@/constants/store-names'
export default {
  name: 'NavigationComponent',
  components: { SideBar, BottomBar },
  props: {
    sideBarWidth: {
      required: true,
      type: String
    },
    bottomBarHeight: {
      required: true,
      type: String
    }
  },
  computed: {
    ...mapGetters({
      inAllowedNotificationPlants: `${NOTIFICATION_SETTINGS}/inAllowedNotificationPlants`,
      inAllowedStockCountPlants: 'stockCount/inAllowedStockCountPlants'
    }),
    items () {
      const items = [
        {
          icon: 'icon-status-monitor',
          text: messages.getTabHeaderStatus(),
          to: { name: 'StatusMonitor' }
        },
        {
          icon: 'icon-priority-call',
          text: messages.getTabHeaderPriority(),
          to: { name: 'PriorityManager' }
        },
        // Note: "inentory" is a typo in the icon pack, not this UI code.
        {
          icon: 'icon-inentory',
          text: messages.getTabHeaderStock(),
          to: { name: 'StockManagement' }
        },
        // Left here on purpose, because KONE asked to hide the navigation until pilot is done and they allow everyone to use stock-count.
        // {
        //   icon: 'icon-circle-plus',
        //   text: messages.getTabHeaderNotifications(),
        //   to: { name: 'Notifications' }
        // },
        {
          icon: 'icon-bubble',
          text: messages.getTabHeaderNotifications(),
          to: { name: NOTIFICATION_PAGE }
        },
        {
          icon: 'icon-people',
          text: messages.getTabHeaderUsers(),
          to: { name: 'UsersManagement' }
        },
        {
          icon: 'icon-maintenance',
          text: messages.getTabHeaderStockCount(),
          to: { name: STOCK_COUNT_PAGE }
        },
        {
          icon: 'icon-user',
          text: messages.getTabHeaderProfile(),
          to: { name: 'UserProfile' }
        },
        {
          icon: 'icon-info',
          text: messages.getTabHeaderInfo(),
          to: { name: 'HelpPage' }
        },
        {
          icon: 'icon-PCBA',
          text: messages.getLabelDashboard(),
          to: { name: 'DashboardStartPage' }
        }
      ]
      return items
    },
    filteredItems () {
      let items = this.items
      // Same rule as PriorityManager.vue's own guard, so the tab cannot offer a
      // page that immediately redirects (KPT-1049).
      if (!mayAccessPriorityManager(this.$store.state.profile.permissions)) {
        items = items.filter(item => item.to.name !== 'PriorityManager')
      }
      if (!this.$store.getters.isPermitted(stockManagement.get)) {
        items = items.filter(item => item.to.name !== 'StockManagement')
      }
      if (!this.$store.getters.isPermitted(userManagement.get)) {
        items = items.filter(item => item.to.name !== 'UsersManagement')
      }
      // UAP notification filter removed: Notifications page is now enabled for all users
      if (!this.inAllowedStockCountPlants) {
        items = items.filter(item => item.to.name !== STOCK_COUNT_PAGE)
      }
      return items
    }
  }
}
</script>

<style scoped>
</style>
